import { BaseLayout } from "layouts/common/BaseLayout";
import { InsideLayoutProvider } from "layouts/common/inside/InsideLayoutProvider";
import { FoundationMenu } from "layouts/FoundationLayout/FoundationMenu";
import * as React from "react";
import { PropsWithChildren } from "react";
import { Outlet } from "react-router";

////////////////////////////////////////////////////////////////////////////////////////////////////////

export const FoundationLayout: React.FC<PropsWithChildren> = (props) => {
    return (
        <BaseLayout>
            <InsideLayoutProvider
                lateralMenu={<FoundationMenu />}
                showCloseButtonWhileMenuOpened={false}
                subHeaderAlwaysVisible={true}
            >
                <Outlet />
            </InsideLayoutProvider>
        </BaseLayout >
    );
};
